'use client';

import type { FC, ReactNode } from 'react';

interface DesktopResultLayoutProps {
  card: ReactNode;
  actions: ReactNode;
  title?: ReactNode;
}

export const DesktopResultLayout: FC<DesktopResultLayoutProps> = ({ card, actions, title }) => (
  <div className="flex items-stretch justify-center p-6 gap-6 w-full">
    <div className="w-[420px] shrink-0">{card}</div>

    <div className="w-[340px] shrink-0 flex flex-col justify-center gap-3 [&>*]:px-0">
      {title}
      {actions}
    </div>
  </div>
);
